import { useCallback } from 'react';
import { useActiveSubmenu } from '../../ActiveSubmenu/ActiveSubmenuProvider';
let timeout = null;
const useDropdown = (id, isSideMenu) => {
    const { activeSubmenu: activeDropdown, clearActiveSubmenu, claimActiveSubmenu, } = useActiveSubmenu(id);
    const handleOnMouseDown = useCallback(e => {
        e.preventDefault();
        if (isSideMenu && activeDropdown === id) {
            clearActiveSubmenu();
        }
        else {
            claimActiveSubmenu();
        }
    }, [activeDropdown, claimActiveSubmenu, clearActiveSubmenu, id, isSideMenu]);
    const handleOnKeyDown = useCallback(e => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (isSideMenu && activeDropdown === id) {
                clearActiveSubmenu();
            }
            else {
                claimActiveSubmenu();
            }
        }
    }, [activeDropdown, claimActiveSubmenu, clearActiveSubmenu, id, isSideMenu]);
    const handleOnMouseLeave = useCallback(() => {
        timeout = setTimeout(() => {
            if (activeDropdown === id) {
                clearActiveSubmenu();
            }
        }, 500);
    }, [clearActiveSubmenu, activeDropdown, id]);
    const handleOnMouseEnter = useCallback(() => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        claimActiveSubmenu();
    }, [claimActiveSubmenu]);
    return {
        open: activeDropdown === id,
        handlers: {
            handleOnKeyDown,
            handleOnMouseDown,
            handleOnMouseEnter,
            handleOnMouseLeave,
        },
    };
};
export default useDropdown;
//# sourceMappingURL=useDropdown.js.map